/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable react/no-unused-class-component-methods -- needed */
/* eslint-disable react/no-unused-state -- needed */
/* eslint-disable no-unused-vars -- needed */
/* eslint-disable react/forbid-prop-types -- needed */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { FormattedMessage } from 'react-intl';
import { Link, Button, Heading } from '@americanexpress/dls-react';
import { IconChevronRight } from '@americanexpress/dls-icons';
import styles from './filter.css';
import { AllThings, ViewAllFilters } from './LanguageObjects';

import SearchBox from '../searchBox/searchBox';

import { allBenefits } from '../../../../constants';

export class Filterbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedcat: 'Benefits',
      numberToShow: 4,
      dropdownMenu: false,
      buttonToHighlight: 'All Benefits',
      benefitLabel: allBenefits,
    };
  }

  componentDidMount() {
    if (!this.props.filter || !this.props.filter.categories) {
      return null;
    }
    const { filter, selectedByProp, typeOfThingPlural, allThingsList } = this.props;
    if (selectedByProp && filter[selectedByProp]) {
      this.setNewFilter(selectedByProp);
    } else {
      this.setNewFilter(AllThings(typeOfThingPlural));
    }
    this.handleClick = this.handleClick.bind(this);
    return null;
  }

  componentDidUpdate(prevProps) {
    const searchFilterCheck = this.props.searchFilter !== '' && prevProps.searchFilter === '';

    if (prevProps?.cardname !== this.props?.cardname || searchFilterCheck) {
      this.setState({
        selectedcat: 'Benefits',
        buttonToHighlight: 'All Benefits',
        benefitLabel: allBenefits,
      });
    }
  }

  // cat is a string of category name
  // drop is used to distinguish categories in dropdown
  setNewFilter = (cat) => {
    this.hideDropDown();
    this.setState({
      selectedcat: cat,
    });

    let newList = [];
    let selectedCategory = 'All';
    if (typeof cat === 'object') {
      // If cat is an object, its the All Things languageObject
      newList = this.props.allThingsList;
    } else if (this.props.filter[cat]) {
      selectedCategory = cat;
      newList = this.props.filter[cat];
    }
    this.props.onCategorySelection(newList, selectedCategory);
  };

  seeMoreFilters = () => {
    this.setState({ numberToShow: this.props.filter.categories.length });
  };

  seeLessFilters = () => {
    this.setState({
      numberToShow: 4,
      selectedcat: AllThings(this.props.typeOfThingPlural),
    });
    this.setNewFilter(AllThings(this.props.typeOfThingPlural));
  };

  hideDropDown = () => {
    this.setState({
      dropdownMenu: false,
    });
  };

  toggleDropDown = () => {
    this.setState({ dropdownMenu: !this.state.dropdownMenu });
  };

  // Change button color on click
  handleClick = (e) => {
    // Toggle button background
    this.setState({
      buttonToHighlight: e.target.name,
    });

    // Filter tiles for the selected category
    this.setNewFilter(e.target.name, false);

    // Match label with selected category
    this.setState({
      benefitLabel: e.target.name,
    });
  };

  render() {
    if (!this.props.filter || !this.props.filter.categories) {
      return null;
    }
    let viewfilters;
    // toggle buttons to show for View all filters / View less filters
    if (
      this.props.filter.categories
      && this.props.filter.categories.length > 4
      && this.state.numberToShow === 4
    ) {
      viewfilters = (
        <Button
          variant="tertiary"
          tabIndex={0}
          onClick={this.seeMoreFilters}
          className="margin-0-t margin-b"
          id="seeMoreFilters"
        >
          {ViewAllFilters(this.props.typeOfThing.toLowerCase())}
        </Button>
      );
    } else if (
      this.props.filter.categories
      && this.props.filter.categories.length > 4
      && this.state.numberToShow > 4
    ) {
      viewfilters = (
        <Button
          variant="tertiary"
          onClick={this.seeLessFilters}
          className="margin-0-t margin-b"
          id="seeLessFilters"
        >
          <FormattedMessage
            id="filterbar - View less filters"
            defaultMessage="View less filters"
          />
        </Button>
      );
    }

    // used to responsively adjust width of filterbar
    const numberOfButtons = this.props.numberofbuttons;

    // Creates an array of left half buttons
    const leftButtons = this.props.filter.categories.filter(
      (value) => value === 'Enroll'
        || value === 'Membership Rewards'
        || value === 'Rewards'
        || value === 'Cash Back'
    );

    // Creates an array of right half buttons
    const rightButtons = this.props.filter.categories.filter(
      (value, index) => value !== 'Enroll'
        && value !== 'Membership Rewards'
        && value !== 'Rewards'
        && value !== 'Cash Back'
        && value !== 'categories'
        && value !== 'category'
        && value !== 'filteredBenefits'
        && index > -1
        && index <= numberOfButtons + 1
    );

    let resultsDisplay;
    if (this.props.searchFilter.length > 2) {
      resultsDisplay = (
        <p aria-live="polite" aria-atomic="true">
          <FormattedMessage
            id="view-all.search.results"
            defaultMessage="Results: "
          />
          {this.props.searchFilterData.length}
        </p>
      );
    } else {
      resultsDisplay = (
        <p aria-live="polite" aria-atomic="true">
          <FormattedMessage
            id="view-all.search.results"
            defaultMessage="Results: "
          />
          {this.props.searchFilterData.length}
        </p>
      );
    }

    const analytics = this.props?.analytics;
    const track = analytics?.track;

    const centurionClass = this.props?.searchExperience === true
      ? `pad-responsive stack flex flex-column flex-justify-center ${styles.centurionCardSearch}`
      : `pad-responsive stack flex flex-column flex-justify-center ${styles.centurionCard}`;

    return (
      <div>
        <div className={styles.hiddenDown}>
          <div className="filter-bar">
            <div
              className={
                this.props.centurionButtonProps !== null
                  ? centurionClass
                  : `stack flex flex-column flex-justify-center ${styles.card}`
              }
            >
              <Heading level={2} variant="sans-small-regular" className="color-text-subtle margin-0-b">
                {this.state.benefitLabel}
              </Heading>
              <div
                className={`flex flex-justify-between flex-align-center float-left color-text-subtle margin-0-t margin-1-b ${styles.viewButtons}`}
              >
                <div
                  className="body color-text-subtle"
                  role="heading"
                  aria-level="3"
                >
                  <FormattedMessage
                    id="view-all.filter.refine"
                    defaultMessage="Refine by Category"
                  />
                </div>
                <span className="float-right">
                  {this.props.centurionButtonProps && (
                    <a
                      className="pad-1-l no-underline"
                      href={this.props.centurionButtonProps.href}
                    >
                      <Button
                        variant="primary"
                        id="Centurion"
                        name="Centurion"
                        identifier="Filter Bar"
                      >
                        <FormattedMessage
                          id="view-all.card-banner.go-to"
                          defaultMessage="Go to"
                        />
                        Centurion.com &nbsp;&nbsp;&nbsp;&nbsp;
                        <IconChevronRight size="md" color="white" />
                      </Button>
                    </a>
                  )}
                </span>
              </div>

              <span className="margin-1-t margin-2-b margin-2-r">
                <hr />
              </span>
              <section className={`flex ${styles.filterButtons}`}>
                <div className="margin-1-r margin-1-l margin-0-r-sm-down color-text-brand body-small-bold font-weight-bold">
                  <Button
                    variant="tertiary"
                    id="All Benefits"
                    name="All Benefits"
                    className={
                      this.state.buttonToHighlight === 'All Benefits'
                        ? `pad-1 margin-1-r font-weight-bold ${styles.btnWidth44}`
                        : `pad-1 margin-1-r font-weight-bold ${styles.btnWidth44}`
                    }
                    aria-pressed={
                      this.state.buttonToHighlight === 'All Benefits'
                        ? 'true'
                        : 'false'
                    }
                    identifier="Filter Bar"
                    reactlytics={{ element: 'filter>>all' }}
                    onClick={this.handleClick}
                  >
                    <FormattedMessage
                      id="view-all.filter.all"
                      defaultMessage="All"
                    />
                  </Button>
                  {leftButtons.map((value, index) => (
                    <Button
                      variant="tertiary"
                      key={uuidv4()}
                      id={value}
                      name={value}
                      className={
                        this.state.buttonToHighlight === value
                          ? `pad-1 margin-1-r font-weight-bold ${styles.btnWidth44}`
                          : `pad-1 margin-1-r font-weight-bold ${styles.btnWidth44}`
                      }
                      aria-pressed={
                        this.state.buttonToHighlight === value
                          ? 'true'
                          : 'false'
                      }
                      identifier="Filter Bar"
                      reactlytics={{
                        element: `filter>>${value?.replace(/ /g, '-').toLowerCase()}`,
                      }}
                      onClick={this.handleClick}
                    >
                      {value}
                    </Button>
                  ))}
                  {window.screen.availWidth >= 768 ? (
                    <span
                      className="color-text-subtle pad-1-l margin-1-r"
                      data-testid="span-element"
                    />
                  ) : null}
                  {rightButtons.map((value, index) => (
                    <Button
                      variant="tertiary"
                      key={uuidv4()}
                      id={value}
                      name={value}
                      className={
                        this.state.buttonToHighlight === value
                          ? `pad-1 margin-r font-weight-bold ${styles.btnWidth44}`
                          : `pad-1 margin-r font-weight-bold ${styles.btnWidth44}`
                      }
                      aria-pressed={
                        this.state.buttonToHighlight === value
                          ? 'true'
                          : 'false'
                      }
                      identifier="Filter Bar"
                      reactlytics={{
                        element: `filter>>${value?.replace(/ /g, '-').toLowerCase()}`,
                      }}
                      onClick={this.handleClick}
                    >
                      {value}
                    </Button>
                  ))}
                </div>
              </section>
              <span className="margin-0-t margin-2-b margin-2-r">
                <hr />
              </span>
              <div
                className="flex"
                style={
                  window.screen.availWidth > 425
                    ? ''
                    : { flexDirection: 'column', width: '95%' }
                }
              >
                <SearchBox
                  id="df-search"
                  type="filter"
                  searchExperience={this.props.searchExperience}
                  dataTestid="searchFilter"
                  data-testid="df-search"
                  disabled=""
                  value={this.props.searchFilter || ''}
                  onClick={() => {
                    track({
                      event: {
                        element: `${this.props?.cardname}>>search>>enter-text`,
                        type: 'click',
                      },
                    });
                  }}
                  onChange={this.props.handleSearch}
                  loading=""
                  autoFocus={this.props.searchFilter}
                  clearButtonProps={{
                    reactlytics: {
                      element: `${this.props?.cardname?.replace(/ /g, '-').toLowerCase()}>>search>>clear-text`,
                    },
                  }}
                  reactlytics={{ disable: true }}
                />
                <div
                  className={
                    window.screen.availWidth > 425
                      ? 'flex pad-tb pad-2-l'
                      : null
                  }
                >
                  {this.props.searchFilter.length > 0 ? resultsDisplay : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Filterbar.propTypes = {
  cardname: PropTypes.string,
  typeOfThing: PropTypes.string,
  typeOfThingPlural: PropTypes.string,
  filter: PropTypes.shape({
    categories: PropTypes.array,
  }).isRequired,
  searchFilter: PropTypes.string,
  searchFilterData: PropTypes.array,
  searchExperience: PropTypes.bool,
  handleSearch: PropTypes.func,
  numberofbuttons: PropTypes.number.isRequired,
  onCategorySelection: PropTypes.func.isRequired,
  allThingsList: PropTypes.arrayOf(PropTypes.string),
  selectedByProp: PropTypes.string,
  centurionButtonProps: PropTypes.shape({
    href: PropTypes.string,
  }),
};

Filterbar.defaultProps = {
  typeOfThing: '',
  typeOfThingPlural: '',
  selectedByProp: '',
  centurionButtonProps: null,
  searchExperience: false,
};

export default Filterbar;
